import { useMemo } from 'react';
import { find, first, isEmpty } from 'lodash';
import useTestTypeArrayObjectContext from './TestTypeArrayObjectContextProvider';
import useTestTypeObjectContext from './TestTypeContextProvider';

export const useTestTypeArrayContext = (testTypeId, groupExist = true) => {
    const testTypeArrayObjectContext = useTestTypeArrayObjectContext();
    return useMemo(() => {
        if (!groupExist) {
            return null;
        }
        if (isEmpty(testTypeArrayObjectContext)) {
            return null;
        }

        const { testTypeArrayObject } = testTypeArrayObjectContext;

        if (isEmpty(testTypeArrayObject)) {
            return null;
        }

        if (testTypeArrayObject.length === 1) {
            return testTypeArrayObject[0];
        }

        if (!testTypeId) {
            return first(testTypeArrayObject);
        }

        return find(testTypeArrayObject, (type) => type._id === testTypeId);
    }, [groupExist, testTypeArrayObjectContext, testTypeId]);
};

export const useTestTypeContext = () => {
    const { testType } = useTestTypeObjectContext();

    const group = testType?.group;
    const typeName = testType?.name;
    const typeId = testType?._id;
    const isBttTest = testType?.bttTest === true;

    return useMemo(() => {
        return {
            group,
            typeName,
            typeId,
            isBttTest,
            testType,
        };
    }, [group, typeName, typeId, isBttTest, testType]);
};
